import { Box, Button, TextField } from "@mui/material";
import {
    Form,
    useLoaderData,
    useParams
} from "react-router-dom";
import { Result } from "../../types/Result";
import { City } from "./type";

export default function CityForm() {
    const params = useParams();
    const data = useLoaderData() as Result<City>;
    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '800px' } }}>
            <Form method="post">
                <TextField
                    placeholder="Kod"
                    type="text"
                    name="cityCode"
                    value={data.data?.cityCode}
                    fullWidth
                    margin="dense"
                    label="Kod"
                    disabled={params.cityCode !== "new"}
                    required
                />
                <TextField
                    required
                    placeholder="Ad"
                    type="text"
                    name="cityName"
                    defaultValue={data.data?.cityName}
                    fullWidth
                    margin="dense"
                    label="Ad"
                />
                <Button fullWidth type="submit" variant="contained">Kaydet</Button>
            </Form>
        </Box>
    );
}